<template>
  <div id="chart">
    <apexchart
      ref="line"
      type="line"
      height="100%"
      :options="chartOptions"
      :series="series"
    ></apexchart>
  </div>
</template>

<script>
/**
 * @Author : Tarun Rawat
 *
 *
 *
 */

import { Grid, XAxisConfig, YAxisConfig, Legend } from './charts.global.config';
import { mapGetters } from 'vuex';

export const colors = ['#39B555', '#F59601', '#F16754'];
export const getColor = (index) => {
  if (index >= colors.length || index < 0) index = 0;
  return colors[index];
};

export default {
  props: {
    customStyle: { type: Object, default: () => {} },
    graphData: { type: Array, default: () => [] },
    intervalTime: { type: Array, default: () => {} },
    title: { type: Object, default: () => {} },
    colors: { type: Array, default: () => ['#FEFCAC', '#28EFC9'] },
  },
  data() {
    return {
      series: [],
    };
  },
  watch: {
    graphData(newValue) {
      this.setSeriesData(newValue);
    },
  },
  computed: {
    ...mapGetters('globalState/settings', ['getDurationTime']),
    chartOptions() {
      return {
        xaxis: {
          ...XAxisConfig,
          tickAmount: this.intervalTime.length > 14 ? 5 : 3,
          title: {
            text: this.$t('time'),
            ...XAxisConfig.title,
          },

          labels: XAxisConfig.labels,
        },
        yaxis: {
          tickAmount: 5,
          decimalsInFloat: 1,
          ...YAxisConfig,
          title: {
            text: this.$t('no-of-users'),
            ...YAxisConfig.title,
          },
          labels: {
            ...YAxisConfig.labels,
          },
        },
        colors: this.colors,
        chart: {
          toolbar: {
            show: false,
          },
          type: 'line',
          zoom: {
            enabled: false,
          },
        },
        dataLabels: {
          enabled: false,
        },
        tooltip: {
          enabled: true,
          theme: 'dark',
          fillSeriesColor: false,
          style: {
            fontSize: '12px',
            fontFamily: undefined,
            background: 'black',
          },
        },
        grid: Grid,

        stroke: {
          curve: 'straight',
          width: 3,
        },
        legend: {
          labels: {
            colors: ['#FFFFFF'],
          },
          formatter: (seriesName, opts) => {
            return [seriesName, ' - ', this.series[opts.seriesIndex].total];
          },
        },
      };
    },
  },
  methods: {
    setSeriesData(_seriesList) {
      this.series = [];
      _seriesList.forEach((_series, outerIndex) => {
        let index = 0;
        let totalCount = 0;
        let newSeries = { name: _series.name, data: [], total: 0 };
        let data = [];
        while (index < this.intervalTime.length) {
          data.push({
            x: this.intervalTime[index],
            y: _series.values.values.values[index].value,
          });
          totalCount += _series.values.values.values[index].value;
          index++;
        }
        newSeries.data = data;
        newSeries.total = totalCount;
        this.series.push(newSeries);
      });
    },
  },
};
</script>
<style lang="scss">
#chart {
  height: 100%;
}
</style>
